module.exports = __webpack_public_path__ + "static/media/calling_up1.7de3b43a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/calling_up1.pdf
// module id = 783
// module chunks = 2